export const ISSUED_REQUEST_STATUS = "issued";
export const COMPLETED_REQUEST_STATUS = "completed";
export const PENDING_REQUEST_STATUS = "pending";
export const PROSPECTIVE_REQUEST_STATUS = "prospective_client";
export const CANCELED_REQUEST_STATUS = "cold";
export const PAID_SPEAKING_FEE_STATUS = "request_to_meet";
export const PAID_LESSON_FEE_STATUS = "payed";
export const BOOKED_LESSONS_STATUS = "booked";
export const CLIENT_UNREACHABLE_STATUS = "not_reachable";
export const CANT_AFFORD_PRICE_STATUS = "cant_afford_price";
export const CLIENT_UNDECIDED_STATUS = "found_manually";
export const NO_AVAILABLE_TUTOR_STATUS = "book_later";

export const ACCEPT_ACTION = "accepted";
export const DECLINE_ACTION = "declined";
export const CHAT_ACTION = "chat";
export const FLAG_ACTION = "flag";
export const CONTACT_CLIENT_ACTION = "contact"; // problematic with the status. need to know which one to use.
export const SUBMIT_FEEDBACK_ACTION = "feedback";
export const VIEW_CALL_TIPS_ACTION = "call_tips";
export const BOOK_LESSONS_ACTION = "book_lessons";
export const SHOW_EARNINGS_ACTION = "show_earnings";

export const PENDING_RESPONSE_STAGE = "pending_response";
export const GET_CLIENT_CONTACT_STAGE = "get_contact";
export const CALL_CLIENT_STAGE = "call_client";
export const SUBMITTED_FEEDBACK_STAGE = "submitted_feedback";
export const BOOKED_LESSONS_STAGE = "booked_lessons";

export const PENDING_RESPONSE = "pending";
export const ACCEPTED_RESPONSE = "accepted";
export const DECLINED_RESPONSE = "declined";
export const NO_RESPONSE = "no_response";
export const APPLIED_RESPONSE = "applied";
export const REPLACED_RESPONSE = "replaced";

export const LOST_REQUESTS_STATUS = [
  CANCELED_REQUEST_STATUS,
  CLIENT_UNREACHABLE_STATUS,
  CANT_AFFORD_PRICE_STATUS,
  CLIENT_UNDECIDED_STATUS,
  NO_AVAILABLE_TUTOR_STATUS,
];
